/* eslint-disable @typescript-eslint/no-var-requires */
import React from 'react';
import './component002.less';

interface IComponent002Props {
  className?: string;
  title1: string;
  img1: string;
  title2: string;
  img2: string;
}

const Component002: React.FunctionComponent<IComponent002Props> = ({
  title1,
  img1,
  title2,
  img2,
  className,
}) => {
  return (
    <>
      <div className={`component002 ${className}`}>
        <div className="cando-section">
          <div className="can-do">
            <div className="cando-title" style={{ backgroundColor: '#46C87A' }}>
              {title1}
            </div>
            <div className="cando-body">
              <img
                className="cando-content"
                src={require(`../../../../../assets/${img1}`).default}
                alt=""
              />
            </div>
          </div>
          <div className="can-not-do">
            <div className="cando-title" style={{ backgroundColor: '#46C87A' }}>
              {title2}
            </div>
            <div className="cando-body">
              <img
                className="cando-content"
                src={require(`../../../../../assets/${img2}`).default}
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Component002;
